import { connect } from 'react-redux';
import PassportDetailsComponent from './PassportDetailsComponent';
import {
  getData,
  getFormErrors,
  getValidators,
  isRequired,
} from '../../../../state/reducers/ApplicationReducer';
import {
  getPassportTypes,
  getPoes,
  getDestinations,
} from '../../../../state/reducers/ConfigReducer';
import { getLanguage } from '../../../../state/reducers/AppReducer';
import ApplicationActions from '../../../../state/actions/ApplicationActions';
import { getDropdownOptions } from '../../../../services/Translation';
import Configs from '../../../../conf';
import { getTargetCountryName } from '../../../../state/selectors/TargetCountrySelector';

const mapStateToProps = (state) => {
  const data = getData(state);
  const validators = getValidators(state);
  const errors = getFormErrors(state);
  const lang = getLanguage(state);

  const targetCountryName = getTargetCountryName(state);

  return {
    passportNumber: data.passportNo || '',
    passportNumberError: errors.passportNo,
    isPassportNumberRequired: isRequired(validators.passportNo),
    placeOfIssue: data.passportPoi || '',
    placeOfIssueError: errors.passportPoi,
    isPlaceOfIssueRequired: isRequired(validators.passportPoi),
    expiryDate: data.passportExpireAt || '',
    expiryDateError: errors.passportExpireAt,
    isExpiryDateRequired: isRequired(validators.passportExpireAt),
    issueDate: data.passportDoi || '',
    issueDateError: errors.passportDoi,
    isIssueDateRequired: isRequired(validators.passportDoi),
    passportType: data.passportTypeId,
    passportTypeError: errors.passportTypeId,
    isPassportTypeRequired: isRequired(validators.passportTypeId),
    passportTypes: getDropdownOptions(getPassportTypes(state), lang),
    portOfEntry: data.poe || '',
    portOfEntryError: errors.poe,
    isPortOfEntryRequired: isRequired(validators.poe),
    portOfEntryOptions: getDropdownOptions(getPoes(state), lang),
    date: data.arrivalAt || '',
    dateError: errors.arrivalAt,
    isDateRequired: isRequired(validators.arrivalAt),
    stayLength: data.lengthStay,
    stayLengthError: errors.lengthStay,
    isStayLengthRequired: isRequired(validators.lengthStay),
    stayLengths: getDropdownOptions(Configs.lengthsOfStay, lang),
    destinations: data.destList,
    destinationsError: errors.destList,
    isDestinationsRequired: isRequired(validators.destList),
    transportationMode: data.destTranspmode,
    transportationModeError: errors.destTranspmode,
    isTransportationModeRequired: isRequired(validators.destTranspmode),
    transportationModes: getDropdownOptions(Configs.modesOfTransport, lang),
    destAddress: data.destAddress || '',
    destAddressError: errors.destAddress,
    isDestAddressRequired: isRequired(validators.destAddress),
    destAddressOptions: getDropdownOptions(getDestinations(state), lang),
    targetCountryName,
  };
};

const { formValueChanged } = ApplicationActions;
const mapDispatchToProps = (dispatch) => ({
  passportNumberChanged: (num) => {
    dispatch(formValueChanged('passportNo', num));
  },
  placeOfIssueChanged: (visaPurpose) =>
    dispatch(formValueChanged('passportPoi', visaPurpose)),
  expiryDateChanged: (date) =>
    dispatch(formValueChanged('passportExpireAt', date)),
  issueDateChanged: (date) => dispatch(formValueChanged('passportDoi', date)),
  passportTypeChanged: (type) =>
    dispatch(formValueChanged('passportTypeId', type)),
  portOfEntryChanged: (poe) => {
    dispatch(formValueChanged('poe', poe));
  },
  dateChanged: (date) => dispatch(formValueChanged('arrivalAt', date)),
  stayLengthChanged: (lengthStay) =>
    dispatch(formValueChanged('lengthStay', lengthStay)),
  destinationsChanged: (destList) =>
    dispatch(formValueChanged('destList', destList)),
  transportationModeChanged: (destTranspmode) =>
    dispatch(formValueChanged('destTranspmode', destTranspmode)),
  destAddressChanged: (destAddress) =>
    dispatch(formValueChanged('destAddress', destAddress)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PassportDetailsComponent);



// WEBPACK FOOTER //
// ./src/view/forms/Application/PassportDetails/index.js